import { Navigate, Outlet } from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { useAuth } from "../auth/AuthContext.js";

export function AdminRoute() {
  const auth = useAuth();
  if (auth.status === "loading") {
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    );
  }
  if (auth.status !== "authenticated" || auth.session?.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return <Outlet />;
}
